import React from "react";
import { avatarColor, initials } from "../shared/avatar";

// Shared mobile-first checklist row: avatar + name + optional subtitle + check
// circle. Used by the everyday Check List and by Emergency Mode.
//   checked  — filled check (tone-colored)
//   dim      — greyed (e.g. "Absent today") but still tappable
//   tone     — "success" (green) | "info" (blue) | "danger" (red)
export default function StudentCheckRow({
  name,
  subtitle,
  checked = false,
  dim = false,
  tone = "success",
  onClick,
}) {
  const label = name || "Unnamed Student";
  return (
    <button
      type="button"
      className={`check-row tone-${tone} ${checked ? "is-checked" : ""} ${dim ? "is-dim" : ""}`}
      onClick={onClick}
    >
      <span className="check-avatar" style={{ background: avatarColor(label) }}>
        {initials(label)}
      </span>
      <span className="check-body">
        <span className="check-name">{label}</span>
        {subtitle && <span className="check-sub">{subtitle}</span>}
      </span>
      <span className="check-mark" aria-hidden="true">
        {checked ? "✓" : ""}
      </span>
    </button>
  );
}
